import { render, staticRenderFns } from "./ProductImageSmall.vue?vue&type=template&id=acace97a&scoped=true"
import script from "./ProductImageSmall.vue?vue&type=script&lang=js"
export * from "./ProductImageSmall.vue?vue&type=script&lang=js"
import style0 from "./ProductImageSmall.vue?vue&type=style&index=0&id=acace97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acace97a",
  null
  
)

export default component.exports